import React from 'react';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';
import { ConfirmationDialog } from '../ui';

export const Footer = ({
  title,
  message,
  modalTitle,
  disabled,
  openModal,
  setOpenModal,
  handleOkClick,
  isLoading,
}) => {
  return (
    <div className="fixed bottom-0 w-full h-[94px] bg-white flex gap-4 items-center justify-center">
      <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
        <DialogTrigger
          className="btn-primary text-primary-button"
          disabled={disabled}
        >
          {modalTitle}
        </DialogTrigger>
        <DialogContent className="max-lg:h-full">
          <ConfirmationDialog
            title={title}
            modalTitle={modalTitle}
            message={message}
            isLoading={isLoading}
            handleOkClick={handleOkClick}
            handleCancelClick={() => setOpenModal(false)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Footer;
